// US States list (for filters and assignment)
export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

export const DRILLER_TYPES = ["Air Rotary", "Mud Rotary", "Environmental"];

export const STATUS_VALUES = ["unclaimed", "claimed", "contacted"];

export const DRILLER_COLORS = {
  "Air Rotary": "#4A6FA5",
  "Mud Rotary": "#B85C38",
  "Environmental": "#4A5D23",
};

export const STATUS_COLORS = {
  unclaimed: "#A8A29E",
  claimed: "#EAB308",
  contacted: "#4A5D23",
};
